import {
   SET_COLLECTIONS,
   ADD_COLLECTION,
   UPDATE_COLLECTION,
   DELETE_COLLECTION,
   SET_RECENTLY_USED_COLLECTIONS,
   SET_SORT_VALUE
} from '../actions';

export default ( state = {
   collections: [],
   recentlyUsedCollections: [],
   isLoading: true,
   sortValue: '',
}, action) => {

   const {
      collections,
      collection,
      sortValue
   } = action;

   switch (action.type) {
      
      case SET_COLLECTIONS: {
         return {
            ...state,
            collections: collections,
            isLoading: false
         }
      }

      case SET_RECENTLY_USED_COLLECTIONS: {
         return {
            ...state,
            recentlyUsedCollections: collections,
            isLoading: false
         }
      }

      case SET_SORT_VALUE: {
         return {
            ...state,
            sortValue: sortValue,
         }
      }

      case ADD_COLLECTION: {
         return {
            ...state,
            collections: [collection, ...state.collections]
         }

      }
      
      case UPDATE_COLLECTION: {
         let updatedCollection = state.collections.find(x => x._id === collection._id);
         let updatedCollectionIndex = state.collections.indexOf(updatedCollection);
         let collections = state.collections;
         collections[updatedCollectionIndex] = collection;

         return {
            ...state, 
            collections: [...collections]
         }
      }
      
      case DELETE_COLLECTION: {

         let deletedCollection = state.collections.find(x => x._id === collection);
         return {
            ...state,
            collections: [...state.collections.filter(x => x !== deletedCollection)]
         }
      }

      default:
            return state;
   }
}